import React from 'react'

import { EXCEPTION_FORM_FIELD, NO_ACCESS_OPTIONS } from '../constants'
import ExceptionToggleField from '../ExceptionToggleField'

import type { ExceptionFormValues } from '../constants'
import type { Control } from 'react-hook-form'

// No Access: the sub-option (Blocked / Not out / Locked) persists through `description`.
type NoAccessFieldsProps = {
  control: Control<ExceptionFormValues>
}

const NoAccessFields: React.FC<NoAccessFieldsProps> = ({ control }) => (
  <ExceptionToggleField control={control} name={EXCEPTION_FORM_FIELD.DESCRIPTION} options={NO_ACCESS_OPTIONS} />
)

export default NoAccessFields
